<div class="wrapper">
  <span class="material-icons">done</span>
  <span class="text">{{text | translate}}</span>
</div>
